<template>
  <div>
    <div v-loading="loading"
         element-loading-text="加载中……"
         element-loading-spinner="el-icon-loading" style="height: 50px">

    </div>
    <el-timeline>
      <div v-for="(notify,index) in notifyList" :key="index">
        <el-timeline-item :timestamp="`${notify.created_at} ${notify.status===1?'已读':'未读'} `" placement="top">
          <el-card>
            <h4><span>{{ notify.sender_name }} </span>{{ notify.object }}</h4>
            <el-link type="info"><span @click="dumpToPage(notify,index)">
                    {{ notify.message }}</span></el-link>
          </el-card>
        </el-timeline-item>
      </div>
    </el-timeline>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination
            v-if="initPaging"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :layout="defaultLayout"
            :total="dataTotal"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getNotifyList, readNotify} from "@/api/notify";

export default {
  name: "NotifyList",
  props: {
    type: {
      type: String,
      default() {
        return 'unread'
      }
    }
  },
  computed: {
    // ---- 分页相关配置 -------
    // 每页条数，切换
    pageSizes() {
      if (!(typeof (this.pagingData.page_size) === 'undefined') && this.pagingData.page_size < 10) {
        return [this.pagingData.page_size]
      }
      return [50, 100, 200]
    },
    // 每一页大小，默认
    pageSize() {
      if (this.pagingData && !(typeof (this.pagingData.page_size) === 'undefined')) {
        return this.pagingData.page_size
      }
      return 10
    },
    // 初始化分页
    initPaging() {
      if (!(typeof (this.pagingData) === 'undefined')) {
        if (this.pagingData.is_show && this.pagingData.total > this.pageSize) {
          return true
        }
      }
      return false
    },
    // 数组总数
    dataTotal() {
      return this.pagingData.total
    },
    // 数据偏移量，分页序号使用
    dataOffset() {
      return typeof (this.pagingData.offset) === 'undefined' ? 0 : this.pagingData.offset
    },
    // 默认分页结构
    defaultLayout() {
      if (!(typeof (this.pagingData) === 'undefined')) {
        if (this.pagingData.layout) {
          return this.pagingData.layout
        }
      }
      return 'total, sizes, prev, pager, next, jumper'
    }
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      apePageSize: 15,
      notifyList: [],
      searchCondition: {is_read: 'N'},
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 15
      },
    }
  },
  created() {
    this.searchCondition.is_read = 'N'
    switch (this.type) {
      case 'unread':
        this.searchCondition.is_read = 'N';
        break;
      case 'read':
        this.searchCondition.is_read = 'Y';
        break;
      default:
        this.searchCondition.is_read = null;
        break;
    }
  },
  methods: {
    init() {
      this.initList()
    },
    // pageSize 改变时处理
    handleSizeChange(val) {
      // this.pageSize = val
      this.apePageSize = val
      this.currentPage = 1
      this.initList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.initList()
    },
    // 解决当前页数据全部删除完空白作用
    getPagingInfo(type = 'no_del') {
      if (type === 'del' && (this.pagingData.total - 1) <= (this.currentPage - 1) * this.pageSize) {
        this.currentPage = this.currentPage - 1 > 0 ? this.currentPage - 1 : 1
      }
      const pagingInfo = {
        page_size: this.apePageSize ? this.apePageSize : this.pageSize,
        per_page: this.apePageSize ? this.apePageSize : this.pageSize,
        current_page: this.currentPage,
        page: this.currentPage

      }
      return pagingInfo
    },
    initList(type) {
      this.loading = true
      this.notifyList = []
      this.pagingData.total = 0;
      const pagingInfo = this.getPagingInfo(type)
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      getNotifyList(searchCondition).then((res) => {
        this.loading = false
        if (res.model) {
          let pageData = res.model
          this.pagingData.total = pageData.total * 1
          this.pagingData.page_size = pageData.per_page * 1

          this.$nextTick(() => {
            this.notifyList = pageData.data
          })
        }

      })
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      if (this.searchCondition.is_read) {
        condition.is_read = this.searchCondition.is_read
      }

      return condition
    },
    dumpToPage(notify, index) {
      if (notify.status === 0) {
        this.notifyList[index].status = 1
        readNotify({id: notify.id}).then((res) => {
          if (res.success) {
            this.$emit('readCallback')
          }
        })
      }

      const {href} = this.$router.resolve({
        path: notify.url,
        query: {object_id: notify.object_id}
      });
      window.open(href, "_blank");
    },
  }
}
</script>

<style scoped>

</style>